module.exports = __webpack_public_path__ + "static/media/pt-br.74e7bedb.png";